import { cssVariables } from "@/utils/utils";
import { Popover } from "antd";
import AntIcon from "../../icons/AntIcon";

interface Props {
  label?: React.ReactNode;
  popoverTitle?: string;
  popoverContent: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const LabelWithPopover = ({ label, popoverTitle, popoverContent, className, style }: Props) => (
  <span className={className} style={style}>
    {label && <>{label}&nbsp;</>}
    <Popover
      style={{ color: cssVariables.colorText }}
      title={popoverTitle ? <b style={{ color: cssVariables.colorText }}>{popoverTitle}</b> : undefined}
      content={popoverContent}
    >
      <span>
        <AntIcon type="question" className="cursor-help" />
      </span>
    </Popover>
  </span>
);

export default LabelWithPopover;
